
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"fill":"none","stroke":"#193880","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.25","d":"M488.75 362.813h22.5a1.875 1.875 0 011.875 1.875v20.625a1.875 1.875 0 01-1.875 1.875h-22.5a1.875 1.875 0 01-1.875-1.875v-20.625a1.875 1.875 0 011.875-1.875zM486.875 368.438h26.25M496.25 368.438v18.75M496.25 377.813h16.875"}}),_c('g',{attrs:{"stroke":"null"}},[_c('path',{staticClass:"a",attrs:{"stroke":"#193880","stroke-width":"1.25","stroke-linejoin":"round","stroke-linecap":"round","fill":"none","d":"M3.159 2.033h13.682a1.875 1.875 0 011.875 1.875v12.436a1.875 1.875 0 01-1.875 1.875H3.159a1.875 1.875 0 01-1.875-1.875V3.908a1.875 1.875 0 011.875-1.875zM1.284 5.768h17.432M7.51 5.768v12.451M7.51 11.994h11.206"}})])])
          )
        }
      }
    